<template>
  <AppHeader :action="{text: 'Create', route: 'TicketsCreate'}">Tickets</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-3">
    <div class="flex items-center mb-5 bg-white rounded-lg shadow-md justify-evenly">
      <button class="w-full py-1 text-sm text-center text-gray-500 rounded-lg" @click="setTab('Open')" :class="{ 'bg-slate-300 text-gray-700 shadow-sm' : selectedTab == 'Open' }">Open <span v-if="openTickets.length > 0">({{ openTickets.length }})</span></button>
      <button class="w-full py-1 text-sm text-center text-gray-500 rounded-lg" @click="setTab('Assigned')" :class="{ 'bg-slate-300 text-gray-700 shadow-sm' : selectedTab == 'Assigned' }">Assigned <span v-if="assignedTickets.length > 0">({{ assignedTickets.length }})</span></button>
      <button class="w-full py-1 text-sm text-center text-gray-500 rounded-lg" @click="setTab('Closed')" :class="{ 'bg-slate-300 text-gray-700 shadow-sm' : selectedTab == 'Closed' }">Closed</button>
    </div>

    <OpenTickets v-if="selectedTab == 'Open'" :tickets="openTickets"></OpenTickets>
    <AssignedTickets v-if="selectedTab == 'Assigned'" :tickets="assignedTickets"></AssignedTickets>
    <ClosedTickets v-if="selectedTab == 'Closed'" :tickets="closedTickets"></ClosedTickets>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import ClosedTickets from '@/components/tickets/ClosedTickets.vue';
import OpenTickets from '@/components/tickets/OpenTickets.vue';
import AssignedTickets from '@/components/Tickets/AssignedTickets.vue';
import mixin from '@/utils/mixin';

export default {
  name: 'TicketsIndex',
  mixins: [ mixin ],
  components: { AppHeader, Loading, OpenTickets, ClosedTickets, AssignedTickets },
  data() {
    return {
      state: 'loading',
      selectedTab: 'Open',
      openTickets: [],
      closedTickets: [],
      assignedTickets: []
    }
  },

  methods: {
    setTab(tabName) {
      if (this.selectedTab == tabName) return;
      this.selectedTab = tabName;
    },

    getData() {
      this.state = 'loading'

      this.request('GET', 'tickets', null, (resp) => {
        this.state = 'idle';

        if (resp.success) {
          this.openTickets = resp.data.open;
          this.closedTickets = resp.data.closed;
          this.assignedTickets = resp.data.assigned;
        }
      });
    }
  },

  created() {
    this.getData();
  },
}
</script>
